import type { ReactElement, ReactNode } from 'react';

export function ActionRow({
  children,
}: Readonly<{ children: ReactNode }>): ReactElement {
  return <div className="flex items-center justify-end gap-2">{children}</div>;
}
